<template>
    <v-container>
        <!-- main page -->
        <v-row>
            <v-col cols="9" sm="6" md="11" lg="6">
                <v-menu
                    ref="menu1"
                    v-model="menu1"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="dateRangeText"
                            label="Date"
                            hint="MM/DD/YYYY format"
                            persistent-hint
                            prepend-icon="mdi-calendar"
                            v-bind="attrs"
                            v-on="on"
                        ></v-text-field>
                    </template>

                    <v-date-picker v-model="dates" range @input="get_date()">
                    </v-date-picker>
                </v-menu>
            </v-col>
            <v-col cols="3" sm="1" md="1" lg="1" class="fix-flex-end-row">
                <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            v-if="role_name != 'Admin'"
                            fab
                            small
                            :color="
                                chk_export_data == false ? 'green accent-3' : ''
                            "
                            class="mr-1"
                            @click="export_data()"
                            v-bind="attrs"
                            v-on="on"
                            :disabled="chk_export_data == true"
                        >
                            <v-icon
                                v-if="chk_export_data == false"
                                color="teal darken-4"
                                >mdi-file-excel</v-icon
                            >
                            <img
                                v-if="chk_export_data == true"
                                src="../../../assets/all/Loading.gif"
                                style="width: 6%"
                            />
                        </v-btn>
                    </template>
                    <span>Export Data</span>
                </v-tooltip>
            </v-col>
            <v-col
                style="margin-left: -35px"
                cols="3"
                sm="1"
                md="1"
                lg="1"
                class="fix-flex-end-row"
            >
                <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            v-if="role_name != 'Admin'"
                            fab
                            small
                            :color="
                                chk_export_data == false
                                    ? 'yellow accent-3'
                                    : ''
                            "
                            class="mr-1"
                            v-bind="attrs"
                            v-on="on"
                            @click="get_dialog(), get_teamname()"
                            :disabled="chk_export_data == true"
                        >
                            <v-icon
                                v-if="chk_export_data == false"
                                color="black  darken-4"
                                >mdi-chart-areaspline</v-icon
                            >
                        </v-btn>
                    </template>
                    <span>View Dashboard</span>
                </v-tooltip>
            </v-col>
        </v-row>

        <div id="case-agging">
            <v-row>
                <v-col cols="12">
                    <v-row class="" v-if="chk_hpccall == true">
                        <v-col cols="12" class="mar-t-20">
                            <v-simple-table class="table-inv">
                                <template v-slot:default>
                                    <thead>
                                        <tr class="col-tr-1">
                                            <th class="text-center" rowspan="2">
                                                Name
                                            </th>
                                            <th
                                                class="text-center"
                                                colspan="12"
                                            >
                                                Time HappyCall
                                            </th>
                                        </tr>
                                        <tr class="col-tr-1">
                                            <th class="text-center">08:00</th>
                                            <th class="text-center">09:00</th>
                                            <th class="text-center">10:00</th>
                                            <th class="text-center">11:00</th>
                                            <th class="text-center">12:00</th>
                                            <th class="text-center">13:00</th>
                                            <th class="text-center">14:00</th>
                                            <th class="text-center">15:00</th>
                                            <th class="text-center">16:00</th>
                                            <th class="text-center">17:00</th>
                                            <th class="text-center">18:00</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr class="bg-tr-1">
                                            <td
                                                colspan="13"
                                                style="
                                                    text-align: center;
                                                    background-color: #80808054;
                                                "
                                            >
                                                <b>ไม่มีข้อมูล</b>
                                            </td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-col>
                    </v-row>
                    <v-progress-linear
                        v-else-if="datahpccall.length == 0"
                        indeterminate
                        color="cyan"
                    ></v-progress-linear>
                </v-col>
            </v-row>
            <v-row class="" v-if="datahpccall.length != 0">
                <v-col cols="12" class="mar-t-20">
                    <v-simple-table class="table-inv">
                        <template v-slot:default>
                            <thead>
                                <tr class="col-tr-1">
                                    <th class="text-center" rowspan="2">
                                        Name
                                    </th>
                                    <th class="text-center" colspan="12">
                                        Time HappyCall
                                    </th>
                                </tr>
                                <tr class="col-tr-1">
                                    <th
                                        class="text-center"
                                        v-for="(row2,
                                        index2) in datahpccall.hpc_hour"
                                        :key="index2"
                                    >
                                        {{ row2 }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody
                                v-for="(r2, i2) in datahpccall.summary"
                                :key="i2"
                            >
                                <tr class="bg-tr-1">
                                    <td
                                        colspan="13"
                                        style="
                                            text-align: center;
                                            background-color: #80808054;
                                        "
                                    >
                                        <b>{{ r2.hpc_name }}</b>
                                    </td>
                                </tr>
                                <tr v-for="(r22, i22) in r2.status" :key="i22">
                                    <td>{{ r22.status_name }}</td>
                                    <td
                                        v-for="(r222, i222) in r22.hour"
                                        :key="i222"
                                        class="text-right"
                                    >
                                        <div
                                            :style="'color:' + colorx[i222]"
                                            class="fix-td-1"
                                        >
                                            {{ r222.num_cases }}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-col>
            </v-row>
            <v-row class="mar-t-30" v-if="datahpccall.length != 0"> </v-row>
        </div>

        <!-- dialig report -->
        <v-row justify="center">
            <v-dialog
                v-model="dialog"
                fullscreen
                hide-overlay
                transition="dialog-bottom-transition"
            >
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-btn icon dark @click="dialog = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <v-toolbar-title></v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items> </v-toolbar-items>
                    </v-toolbar>
                    <div style="margin-left: 20px; margin-top: 10px">
                        <v-row>
                            <v-col class="d-flex" cols="12" sm="2">
                                <v-select
                                    :items="data_teamname"
                                    v-model="value_teamname"
                                    label="Team Name"
                                    @input="get_tl()"
                                    outlined
                                ></v-select>
                            </v-col>
                            <v-col class="d-flex" cols="12" sm="2">
                                <v-select
                                    :items="data_tl"
                                    v-model="value_tl"
                                    item-text="emp_name_en"
                                    item-value="tl"
                                    label="TL"
                                    @input="get_zone()"
                                    outlined
                                    clearable
                                    @click:clear="value_tl = []"
                                ></v-select>
                            </v-col>
                            <v-col class="d-flex" cols="12" sm="2">
                                <v-select
                                    :items="data_zone"
                                    v-model="value_zone"
                                    label="ZONE"
                                    item-text="branch_name"
                                    item-value="branch_id"
                                    @input="get_ce()"
                                    outlined
                                    clearable
                                    @click:clear="value_zone = []"
                                ></v-select>
                            </v-col>
                            <v-col class="d-flex" cols="12" sm="2">
                                <v-select
                                    :items="data_ce"
                                    v-model="value_ce"
                                    label="CE"
                                    item-text="emp_name_en"
                                    item-value="emp_id"
                                    outlined
                                    clearable
                                    @click:clear="value_ce = []"
                                ></v-select>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col class="d-flex" cols="12" sm="2">
                                <v-menu
                                    ref="menu2"
                                    v-model="menu2"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="dateRangeText1"
                                            label="Date Range"
                                            prepend-icon="mdi-calendar"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="date_dashboard"
                                        min="2022-05-10"
                                        range
                                    ></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col class="d-flex" cols="12" sm="2">
                                <v-select
                                    :items="data_viewas"
                                    v-model="value_viewas"
                                    label="View As"
                                    outlined
                                ></v-select>
                            </v-col>
                            <v-col class="d-flex" cols="12" sm="2" xs="12">
                                <v-btn
                                    x-large
                                    color="#dfffff"
                                    @click="get_dashboard()"
                                >
                                    <v-icon color="green">mdi-magnify</v-icon>
                                    Search</v-btn
                                >
                            </v-col>
                            <v-col class="d-flex" cols="12" sm="3" xs="12">
                                <v-btn
                                    x-large
                                    color="#cdf7eb"
                                    @click="reset_filter()"
                                >
                                    <v-icon color="red">mdi-refresh</v-icon>
                                    Reset Filter</v-btn
                                >
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="4">
                                <v-btn
                                    class="block"
                                    rounded
                                    color="success"
                                    @click="export_report()"
                                >
                                    Export Report
                                </v-btn>
                            </v-col>
                        </v-row>
                    </div>

                    <v-divider></v-divider>
                    <div style="margin-left: 20px">
                        <h1 style="text-align: center">
                            {{ value_viewas == "ce" ? "by ce" : "overall" }}
                        </h1>
                        <v-row style="margin-top: 20px">
                            <v-col
                                v-for="(row, index) in data_dashboard"
                                :key="index"
                                cols="12"
                                md="3"
                            >
                                <v-row>
                                    <v-col cols="12" xs="12" md="12">
                                        <v-card class="mx-auto">
                                            <div
                                                class="test"
                                                v-if="
                                                    value_viewas == 'ce' &&
                                                        button == 0
                                                "
                                            >
                                                <v-row>
                                                    <v-col md="2">
                                                        <v-avatar size="70">
                                                            <v-img
                                                                class="white--text align-end"
                                                                :src="
                                                                    url_pic +
                                                                        row.emp_id
                                                                "
                                                            >
                                                                <v-card-title></v-card-title>
                                                            </v-img>
                                                        </v-avatar>
                                                    </v-col>
                                                    <v-col
                                                        md="7"
                                                        class="text-center font-weight-bold"
                                                    >
                                                        <a
                                                            @click="
                                                                view_detail(
                                                                    row.head,
                                                                    row.emp_id,
                                                                    dateRangeText1
                                                                )
                                                            "
                                                            >{{ row.head }}
                                                        </a>
                                                        <br />
                                                        {{ row.title }}</v-col
                                                    >
                                                    <v-col
                                                        md="3"
                                                        class="heading"
                                                    >
                                                        <h2>
                                                            {{ row.rating_avg }}
                                                        </h2>
                                                    </v-col>
                                                </v-row>
                                            </div>

                                            <v-card-subtitle
                                                v-if="
                                                    value_viewas == 'ce' &&
                                                        button == 0
                                                "
                                                class="pb-0"
                                                style="
                                                    text-align: center;
                                                    font-weight: bold;
                                                    font-size: 16px;
                                                    color: black;
                                                "
                                            >
                                            </v-card-subtitle>
                                            <v-card-subtitle
                                                v-if="
                                                    value_viewas == 'overall' &&
                                                        button == 1
                                                "
                                                class="pb-0"
                                                style="
                                                    text-align: center;
                                                    font-weight: bold;
                                                    font-size: 16px;
                                                    color: black;
                                                "
                                            >
                                                <v-row>
                                                    <v-col md="6">
                                                        {{ row.head }}
                                                    </v-col>
                                                    <v-col md="6">
                                                        {{ row.rating_avg }}
                                                    </v-col>
                                                </v-row>
                                            </v-card-subtitle>

                                            <v-card-text
                                                v-if="
                                                    value_viewas == 'ce' &&
                                                        button == 0
                                                "
                                                class="text--primary"
                                                style="margin-top: 10px"
                                            >
                                                <div style="">
                                                    <v-row>
                                                        <v-col
                                                            cols="6"
                                                            style="
                                                                font-weight: bold;
                                                            "
                                                        >
                                                            Greeting
                                                        </v-col>
                                                        <v-col cols="6">
                                                            <v-progress-linear
                                                                :color="
                                                                    row.greetings >=
                                                                    90
                                                                        ? 'green'
                                                                        : row.greetings >=
                                                                          60
                                                                        ? 'orange'
                                                                        : row.greetings >=
                                                                          30
                                                                        ? 'yellow'
                                                                        : 'red'
                                                                "
                                                                height="20"
                                                                :value="
                                                                    row.greetings
                                                                "
                                                                striped
                                                                ><template
                                                                    v-slot:default="{
                                                                        value,
                                                                    }"
                                                                >
                                                                    <strong>{{
                                                                        Math.ceil(
                                                                            value
                                                                        )
                                                                    }}</strong>
                                                                </template></v-progress-linear
                                                            >
                                                        </v-col>
                                                    </v-row>
                                                </div>
                                                <div>
                                                    <v-row>
                                                        <v-col
                                                            cols="6"
                                                            style="
                                                                font-weight: bold;
                                                            "
                                                        >
                                                            Professional
                                                        </v-col>
                                                        <v-col cols="6">
                                                            <v-progress-linear
                                                                :color="
                                                                    row.personality >=
                                                                    90
                                                                        ? 'green'
                                                                        : row.personality >=
                                                                          60
                                                                        ? 'orange'
                                                                        : row.personality >=
                                                                          30
                                                                        ? 'yellow'
                                                                        : 'red'
                                                                "
                                                                height="20"
                                                                :value="
                                                                    row.personality
                                                                "
                                                                striped
                                                                ><template
                                                                    v-slot:default="{
                                                                        value,
                                                                    }"
                                                                >
                                                                    <strong>{{
                                                                        Math.ceil(
                                                                            value
                                                                        )
                                                                    }}</strong>
                                                                </template></v-progress-linear
                                                            >
                                                        </v-col>
                                                    </v-row>
                                                </div>
                                                <div>
                                                    <v-row>
                                                        <v-col
                                                            cols="6"
                                                            style="
                                                                font-weight: bold;
                                                            "
                                                        >
                                                            Resolve
                                                        </v-col>
                                                        <v-col cols="6">
                                                            <v-progress-linear
                                                                :color="
                                                                    row.resolve >=
                                                                    90
                                                                        ? 'green'
                                                                        : row.resolve >=
                                                                          60
                                                                        ? 'orange'
                                                                        : row.resolve >=
                                                                          30
                                                                        ? 'yellow'
                                                                        : 'red'
                                                                "
                                                                height="20"
                                                                :value="
                                                                    row.resolve
                                                                "
                                                                striped
                                                                ><template
                                                                    v-slot:default="{
                                                                        value,
                                                                    }"
                                                                >
                                                                    <strong>{{
                                                                        Math.ceil(
                                                                            value
                                                                        )
                                                                    }}</strong>
                                                                </template></v-progress-linear
                                                            >
                                                        </v-col>
                                                    </v-row>
                                                </div>
                                                <div>
                                                    <v-row>
                                                        <v-col
                                                            cols="6"
                                                            style="
                                                                font-weight: bold;
                                                            "
                                                        >
                                                            Advice
                                                        </v-col>
                                                        <v-col cols="6">
                                                            <v-progress-linear
                                                                :color="
                                                                    row.advice >=
                                                                    90
                                                                        ? 'green'
                                                                        : row.advice >=
                                                                          60
                                                                        ? 'orange'
                                                                        : row.advice >=
                                                                          30
                                                                        ? 'yellow'
                                                                        : 'red'
                                                                "
                                                                height="20"
                                                                :value="
                                                                    row.advice
                                                                "
                                                                striped
                                                                ><template
                                                                    v-slot:default="{
                                                                        value,
                                                                    }"
                                                                >
                                                                    <strong>{{
                                                                        Math.ceil(
                                                                            value
                                                                        )
                                                                    }}</strong>
                                                                </template></v-progress-linear
                                                            >
                                                        </v-col>
                                                    </v-row>
                                                </div>
                                            </v-card-text>
                                            <v-card-text
                                                v-if="
                                                    value_viewas == 'overall' &&
                                                        button == 1
                                                "
                                                class="text--primary"
                                                style="margin-top: 10px"
                                            >
                                                <div style="">
                                                    <v-row>
                                                        <v-col
                                                            cols="6"
                                                            style="
                                                                font-weight: bold;
                                                            "
                                                        >
                                                            Greeting
                                                        </v-col>
                                                        <v-col cols="6">
                                                            <v-progress-linear
                                                                :color="
                                                                    row.greetings >=
                                                                    90
                                                                        ? 'green'
                                                                        : row.greetings >=
                                                                          60
                                                                        ? 'orange'
                                                                        : row.greetings >=
                                                                          30
                                                                        ? 'yellow'
                                                                        : 'red'
                                                                "
                                                                height="20"
                                                                :value="
                                                                    row.greetings
                                                                "
                                                                striped
                                                                ><template
                                                                    v-slot:default="{
                                                                        value,
                                                                    }"
                                                                >
                                                                    <strong>{{
                                                                        Math.ceil(
                                                                            value
                                                                        )
                                                                    }}</strong>
                                                                </template></v-progress-linear
                                                            >
                                                        </v-col>
                                                    </v-row>
                                                </div>
                                                <div>
                                                    <v-row>
                                                        <v-col
                                                            cols="6"
                                                            style="
                                                                font-weight: bold;
                                                            "
                                                        >
                                                            Professional
                                                        </v-col>
                                                        <v-col cols="6">
                                                            <v-progress-linear
                                                                :color="
                                                                    row.greetings >=
                                                                    90
                                                                        ? 'green'
                                                                        : row.personality >=
                                                                          60
                                                                        ? 'orange'
                                                                        : row.personality >=
                                                                          30
                                                                        ? 'yellow'
                                                                        : 'red'
                                                                "
                                                                height="20"
                                                                :value="
                                                                    row.personality
                                                                "
                                                                striped
                                                                ><template
                                                                    v-slot:default="{
                                                                        value,
                                                                    }"
                                                                >
                                                                    <strong>{{
                                                                        Math.ceil(
                                                                            value
                                                                        )
                                                                    }}</strong>
                                                                </template></v-progress-linear
                                                            >
                                                        </v-col>
                                                    </v-row>
                                                </div>
                                                <div>
                                                    <v-row>
                                                        <v-col
                                                            cols="6"
                                                            style="
                                                                font-weight: bold;
                                                            "
                                                        >
                                                            Resolve
                                                        </v-col>
                                                        <v-col cols="6">
                                                            <v-progress-linear
                                                                :color="
                                                                    row.resolve >=
                                                                    90
                                                                        ? 'green'
                                                                        : row.resolve >=
                                                                          60
                                                                        ? 'orange'
                                                                        : row.resolve >=
                                                                          30
                                                                        ? 'yellow'
                                                                        : 'red'
                                                                "
                                                                height="20"
                                                                :value="
                                                                    row.resolve
                                                                "
                                                                striped
                                                                ><template
                                                                    v-slot:default="{
                                                                        value,
                                                                    }"
                                                                >
                                                                    <strong>{{
                                                                        Math.ceil(
                                                                            value
                                                                        )
                                                                    }}</strong>
                                                                </template></v-progress-linear
                                                            >
                                                        </v-col>
                                                    </v-row>
                                                </div>
                                                <div>
                                                    <v-row>
                                                        <v-col
                                                            cols="6"
                                                            style="
                                                                font-weight: bold;
                                                            "
                                                        >
                                                            Advice
                                                        </v-col>
                                                        <v-col cols="6">
                                                            <v-progress-linear
                                                                :color="
                                                                    row.advice >=
                                                                    90
                                                                        ? 'green'
                                                                        : row.advice >=
                                                                          60
                                                                        ? 'orange'
                                                                        : row.advice >=
                                                                          30
                                                                        ? 'yellow'
                                                                        : 'red'
                                                                "
                                                                height="20"
                                                                :value="
                                                                    row.advice
                                                                "
                                                                striped
                                                                ><template
                                                                    v-slot:default="{
                                                                        value,
                                                                    }"
                                                                >
                                                                    <strong>{{
                                                                        Math.ceil(
                                                                            value
                                                                        )
                                                                    }}</strong>
                                                                </template></v-progress-linear
                                                            >
                                                        </v-col>
                                                    </v-row>
                                                </div>
                                            </v-card-text>
                                            <!-- <v-card-actions>
                      <v-btn color="orange" text>
                        Share
                      </v-btn>

                      <v-btn color="orange" text>
                        Explore
                      </v-btn>
                    </v-card-actions> -->
                                        </v-card>
                                    </v-col>
                                </v-row></v-col
                            >
                        </v-row>
                    </div>
                </v-card>
                <v-dialog v-model="dialog_detail" max-width="1600px">
                    <v-card>
                        <v-card-title>
                            View Detail -
                            <label
                                style="
                                    font-size: 20px;
                                    color: #7499fc;
                                    margin-left: 10px;
                                "
                                >{{ engineer }}
                            </label>
                        </v-card-title>
                        <v-card-text
                            v-for="(row, index) in data_detail"
                            :key="index"
                        >
                            <v-alert
                                dense
                                border="top"
                                color="red lighten-2"
                                dark
                            >
                                <v-row>
                                    <v-col>
                                        {{ row.site_name }}
                                    </v-col>
                                    <v-col>
                                        {{ row.cust_name }}
                                    </v-col>
                                    <v-col>
                                        {{ row.survey_date }}
                                    </v-col></v-row
                                >
                            </v-alert>

                            <v-row>
                                <v-col cols="6" sm="6" md="2"
                                    ><label
                                        style="
                                            color: black;
                                            font-size: 16px;
                                            font-weight: bold;
                                        "
                                        >Greetings :
                                        <v-icon
                                            color="green"
                                            v-if="row.greetings == 'Y'"
                                            >mdi-check-circle</v-icon
                                        >
                                        <v-icon color="red" v-else
                                            >mdi-close-circle</v-icon
                                        >
                                    </label></v-col
                                >

                                <v-col cols="6" sm="6" md="2"
                                    ><label
                                        style="
                                            color: black;
                                            font-size: 16px;
                                            font-weight: bold;
                                        "
                                        >Professional :
                                        <v-icon
                                            color="green"
                                            v-if="row.personality == 'Y'"
                                            >mdi-check-circle</v-icon
                                        >
                                        <v-icon color="red" v-else
                                            >mdi-close-circle</v-icon
                                        >
                                    </label></v-col
                                >

                                <v-col cols="6" sm="6" md="2"
                                    ><label
                                        style="
                                            color: black;
                                            font-size: 16px;
                                            font-weight: bold;
                                        "
                                        >Resolve :
                                        <v-icon
                                            color="green"
                                            v-if="row.resolve == 'Y'"
                                            >mdi-check-circle</v-icon
                                        >
                                        <v-icon color="red" v-else
                                            >mdi-close-circle</v-icon
                                        >
                                    </label></v-col
                                >

                                <v-col cols="6" sm="6" md="2"
                                    ><label
                                        style="
                                            color: black;
                                            font-size: 16px;
                                            font-weight: bold;
                                        "
                                        >Advice :
                                        <v-icon
                                            color="green"
                                            v-if="row.advice == 'Y'"
                                            >mdi-check-circle</v-icon
                                        >
                                        <v-icon color="red" v-else
                                            >mdi-close-circle</v-icon
                                        >
                                    </label></v-col
                                >

                                <v-col cols="6" sm="6" md="2"
                                    ><label
                                        style="
                                            color: black;
                                            font-size: 16px;
                                            font-weight: bold;
                                        "
                                        >Rating : {{ row.rating }}
                                    </label></v-col
                                >
                            </v-row>
                            <v-simple-table>
                                <template v-slot:default>
                                    <thead style="background-color: #fdd5e2">
                                        <tr>
                                            <th
                                                class="text-left"
                                                style="color: black"
                                            >
                                                Case ID
                                            </th>
                                            <th
                                                class="text-left"
                                                style="color: black"
                                            >
                                                Case Title
                                            </th>
                                            <th
                                                class="text-left"
                                                style="color: black"
                                            >
                                                Solution
                                            </th>
                                            <th
                                                class="text-left"
                                                style="color: black"
                                            >
                                                ช่างประเมินลูกค้า
                                            </th>
                                            <th
                                                class="text-left"
                                                style="color: black"
                                            >
                                                ระดับความพึงพอใจของลูกค้า
                                            </th>
                                            <th
                                                class="text-left"
                                                style="color: black"
                                            >
                                                เหตุผล
                                            </th>
                                            <th
                                                class="text-left"
                                                style="color: black"
                                            >
                                                Remark
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="(row1, index1) in row.cases"
                                            :key="index1"
                                        >
                                            <td>{{ row1.case_id }}</td>
                                            <td>{{ row1.case_title }}</td>
                                            <td>{{ row1.solution }}</td>
                                            <td class="text-center">
                                                <v-btn
                                                    v-if="
                                                        row1.ce_customer_level ==
                                                            'L'
                                                    "
                                                    text
                                                    icon
                                                >
                                                    <v-icon
                                                        class="display-1"
                                                        color="red"
                                                        >mdi-emoticon-sad</v-icon
                                                    >
                                                </v-btn>
                                                <v-btn
                                                    v-else-if="
                                                        row1.ce_customer_level ==
                                                            'M'
                                                    "
                                                    text
                                                    icon
                                                >
                                                    <v-icon
                                                        class="display-1"
                                                        color="amber darken-2"
                                                        >mdi-emoticon-neutral</v-icon
                                                    >
                                                </v-btn>
                                                <v-btn
                                                    v-else-if="
                                                        row1.ce_customer_level ==
                                                            'H'
                                                    "
                                                    text
                                                    icon
                                                >
                                                    <v-icon
                                                        class="display-1"
                                                        color="green"
                                                        >mdi-emoticon-excited</v-icon
                                                    >
                                                </v-btn>
                                            </td>
                                            <td class="text-center">
                                                <v-btn
                                                    v-if="row1.hpc_level == 'L'"
                                                    text
                                                    icon
                                                >
                                                    <v-icon
                                                        class="display-1"
                                                        color="red"
                                                        >mdi-emoticon-sad</v-icon
                                                    >
                                                </v-btn>
                                                <v-btn
                                                    v-else-if="
                                                        row1.hpc_level == 'M'
                                                    "
                                                    text
                                                    icon
                                                >
                                                    <v-icon
                                                        class="display-1"
                                                        color="amber darken-2"
                                                        >mdi-emoticon-neutral</v-icon
                                                    >
                                                </v-btn>
                                                <v-btn
                                                    v-else-if="
                                                        row1.hpc_level == 'H'
                                                    "
                                                    text
                                                    icon
                                                >
                                                    <v-icon
                                                        class="display-1"
                                                        color="green"
                                                        >mdi-emoticon-excited</v-icon
                                                    >
                                                </v-btn>
                                            </td>
                                            <td>{{ row1.hpc_level_reason }}</td>
                                            <td>{{ row1.hpc_remark }}</td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-card-text>
                    </v-card>
                </v-dialog>
            </v-dialog>
        </v-row>

        <v-dialog v-model="dialog_loading" hide-overlay persistent width="320">
            <v-card color="primary" dark>
                <v-card-text>
                    <span class="mt-1 white--text">Loading</span>
                    <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0"
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import axios from "axios"
import { mapState, mapMutations } from "vuex"

let url = `${process.env.VUE_APP_ROOT_API}/api/`

export default {
    data() {
        return {
            dialog_loading: false,
            role_name: localStorage.role_name,
            button: 0,
            engineer: "",
            url_pic: `https://api.aittservice.com/api/profile_img/`,
            data_dashboard: [],
            value_teamname: "",
            value_tl: "",
            value_zone: [],
            value_ce: [],
            value_viewas: [],
            data_detail: [],
            data_teamname: [],
            data_tl: [],
            data_zone: [],
            data_ce: [],
            data_viewas: ["ce", "overall"],
            activePicker: null,
            date: null,
            menu: false,
            dialog: false,
            dialog_detail: false,
            chk_hpccall: false,
            chk_export_data: false,
            colorx: [
                "rgb(0, 82, 0)",
                "rgb(13, 97, 13)",
                "rgb(32, 126, 32)",
                "rgb(252, 187, 66)",
                "rgb(245, 118, 33)",
                "rgb(245, 75, 33)",
                "rgb(214, 43, 0)",
            ],
            datahpccall: [],
            dates: [
                new Date().toISOString().substr(0, 10),
                new Date().toISOString().substr(0, 10),
            ],
            date_dashboard: [
                "2022-05-10",
                new Date().toISOString().substr(0, 10),
            ],
            menu1: false,
            menu2: false,
        }
    },

    computed: {
        dateRangeText() {
            this.dates.sort((a, b) => {
                return new Date(a) - new Date(b)
            })
            return this.dates.join(" ~ ")
        },
        dateRangeText1() {
            this.date_dashboard.sort((a, b) => {
                return new Date(a) - new Date(b)
            })
            return this.date_dashboard.join(" ~ ")
        },
    },

    watch: {
        menu(val) {
            val && setTimeout(() => (this.activePicker = "YEAR"))
        },
    },
    mounted() {
        this.get_datacall()
    },
    methods: {
        async export_report() {
            this.dialog_loading = true

            await axios({
                url: url + "happy-call/export-report-2",
                method: "POST",
                responseType: "blob",
                data: { date: this.date_dashboard },
                headers: { Authorization: "Bearer " + localStorage.token },
            }).then((response) => {
                let fileURL = window.URL.createObjectURL(
                    new Blob([response.data])
                )
                let fileLink = document.createElement("a")

                fileLink.href = fileURL
                fileLink.setAttribute("download", "report.xlsx")
                document.body.appendChild(fileLink)

                fileLink.click()
                this.dialog_loading = false
            })
        },
        view_detail(engineer, emp_id, date) {
            this.dialog_detail = true
            this.engineer = engineer
            this.get_detail(emp_id, date)
        },
        async get_detail(emp_id, date) {
            this.dateRangeText2 = []
            this.dateRangeText2.push(this.dateRangeText1.split(" ")[0])
            this.dateRangeText2.push(this.dateRangeText1.split(" ")[2])

            const sent = {
                emp_id: emp_id,
                date: this.dateRangeText2,
            }
            const url = `${process.env.VUE_APP_ROOT_API}/api/ce-performance/report/view`
            try {
                const { data } = await axios.post(url, sent)
                this.data_detail = data
            } catch (error) {
                console.log(error)
            }
        },
        reset_filter() {
            this.value_teamname = []
            this.value_tl = []
            this.value_zone = []
            this.value_ce = []
            this.value_viewas = "overall"
            this.data_dashboard = []
        },
        get_dialog() {
            // console.log("-- dd")
            this.dialog = true
            this.reset_filter()
        },
        async get_teamname() {
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            const url = `${process.env.VUE_APP_ROOT_API}/api/ce-performance/filter`

            try {
                const { data } = await axios.get(url, options)
                this.data_teamname = data.team
            } catch (error) {
                console.log(error)
            }
        },
        async get_tl() {
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            const url =
                `${process.env.VUE_APP_ROOT_API}/api/ce-performance/filter/` +
                this.value_teamname

            try {
                const { data } = await axios.get(url, options)

                this.data_tl = data.tl
            } catch (error) {
                console.log(error)
            }
        },
        async get_zone() {
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            const url =
                `${process.env.VUE_APP_ROOT_API}/api/ce-performance/filter/` +
                this.value_teamname +
                "/" +
                this.value_tl

            try {
                const { data } = await axios.get(url, options)

                this.data_zone = data.zone
            } catch (error) {
                console.log(error)
            }
        },
        async get_ce() {
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            const url =
                `${process.env.VUE_APP_ROOT_API}/api/ce-performance/filter/` +
                this.value_teamname +
                "/" +
                this.value_tl +
                "/" +
                this.value_zone

            try {
                const { data } = await axios.get(url, options)

                this.data_ce = data.ce
            } catch (error) {
                console.log(error)
            }
        },
        async get_dashboard() {
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            const url = `${process.env.VUE_APP_ROOT_API}/api/ce-performance/report`

            if (this.value_tl == "" || this.value_tl == undefined) {
                this.value_tl = ""
            } else if (this.value_tl.length == 0) {
                this.value_tl = ""
            }
            if (this.value_zone == "" || this.value_zone == undefined) {
                this.value_zone = ""
            } else if (this.value_zone.length == 0) {
                this.value_zone = ""
            }
            if (this.value_ce == "" || this.value_ce == undefined) {
                this.value_ce = ""
            } else if (this.value_ce.length == 0) {
                this.value_ce = ""
            }

            if (this.value_viewas != "overall" || this.value_ce != "") {
                this.value_viewas = "ce"
            }

            if (
                this.value_viewas.length == 0 ||
                this.value_viewas == undefined
            ) {
                this.value_viewas = ""
            }
            if (
                this.dateRangeText1.length == 0 ||
                this.dateRangeText1 == undefined
            ) {
                this.dateRangeText2 = []
            } else {
                this.dateRangeText2 = []
                this.dateRangeText2.push(this.dateRangeText1.split(" ")[0])
                this.dateRangeText2.push(this.dateRangeText1.split(" ")[2])
            }

            const sent = {
                team: this.value_teamname,
                tl: this.value_tl,
                zone: this.value_zone,
                ce: this.value_ce,
                show: this.value_viewas,
                date: this.dateRangeText2,
            }
            try {
                if (this.value_viewas != "") {
                    const { data } = await axios.post(url, sent, options)
                    this.data_dashboard = data
                    if (this.value_viewas == "overall") {
                        this.button = 1
                    } else {
                        this.button = 0
                    }
                }
            } catch (error) {
                console.log(error)
            }
        },
        get_date() {
            if (this.dateRangeText.length === 23) {
                this.get_datacall()
                this.menu1 = false
            }
        },
        get_date1() {
            if (this.dateRangeText.length === 23) {
                this.menu2 = false
            }
        },
        async export_data() {
            this.chk_export_data = true
            await axios({
                url: `${process.env.VUE_APP_ROOT_API}/api/happy-call/export-report`,
                method: "POST",
                responseType: "blob",
                data: { date: this.dates },
                headers: { Authorization: "Bearer " + localStorage.token },
            }).then((response) => {
                this.chk_export_data = false
                let fileURL = window.URL.createObjectURL(
                    new Blob([response.data])
                )
                let fileLink = document.createElement("a")

                fileLink.href = fileURL
                fileLink.setAttribute(
                    "download",
                    "reporthappycall" + this.dates + ".xlsx"
                )
                document.body.appendChild(fileLink)

                fileLink.click()
            })
        },
        async get_datacall() {
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }

            const url = `${process.env.VUE_APP_ROOT_API}/api/happy-call/dashboard`
            try {
                const { data } = await axios.post(
                    `${url}`,
                    { date: this.dates },
                    options
                )

                this.datahpccall = data
                this.chk_hpccall = false
            } catch (error) {
                this.datahpccall = []
                this.chk_hpccall = true
                console.log(error)
            }
        },
    },
}
</script>
<style>
.test {
    background-image: url("../../../assets/login/bg2.png");
    background-color: rgba(221, 61, 61, 0.377);
}
</style>
